import { useTranslation } from 'react-i18next'

import {
  useDate,
  useDateLimits,
  useScreen,
  useTimeZone,
} from '../../../../../../../hooks'
import { DateTimePicker } from '../../../../../../DateTime'
import { FormFieldsContainer } from '../../../../../../Form'
import { FormikField } from '../../../../../../Formik'
import {
  LISTING_PUBLICATION_SCHEDULE_FIELD_NAME,
  QA_NAME_LISTING_PUBLICATION_SCHEDULE_FIELD,
} from '../ListingPublicationScheduleModal.constants'

import { getListingPublicationScheduleFieldLimits } from './ListingPublicationScheduleModalFields.utils'

function ListingPublicationScheduleModalFields({ bounds, labelKey }) {
  const { t } = useTranslation()

  const { maxDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen()

  const date = useDate()

  const timezone = useTimeZone()

  const { maxValue, minValue } = getListingPublicationScheduleFieldLimits({
    bounds,
    date,
    maxDate,
    timezone,
  })

  return (
    <FormFieldsContainer>
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t('RentalPortal.ListingFormDatePlaceholderKey'),
        }}
        fieldComponentProps={{
          label: `${t(labelKey)}:`,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={maxValue}
        minValue={minValue}
        name={LISTING_PUBLICATION_SCHEDULE_FIELD_NAME}
        qaName={QA_NAME_LISTING_PUBLICATION_SCHEDULE_FIELD}
        timeProps={{
          placeholder: t('RentalPortal.ListingFormTimePlaceholderKey'),
        }}
      />
    </FormFieldsContainer>
  )
}

export default ListingPublicationScheduleModalFields
